import React, {  } from 'react'
import styled from 'styled-components'
import { auth, provider} from '../firebase'
 

function Login(props)
    {
        console.log("Start of login page")
        const signIn = () => 
        { 
            console.log("SignIn function");
            auth.signInWithPopup(provider)
            .then((result)=>{
                console.log(JSON.stringify(result.user.uid))
                const photo12=result.user.photoURL;
                console.log("user is "+ photo12);
                const name12=result.user.displayName;
                console.log("user is "+ name12);
                const newUser = {
                        id: result.user.uid,
                        name: name12,
                        pic: photo12
                }
                //new user is added to local storage and props
                localStorage.setItem('user',JSON.stringify(newUser));
                props.setUser(newUser);

            })
            .catch((error)=>{
                    alert(error.message)
            })
  
        }

        return (
            <Container>
                <LoginForm>
                    <SlackImg src="http://assets.stickpng.com/images/5cb480cd5f1b6d3fbadece79.png"></SlackImg>
                    <h1>Login Form</h1>
                    <SigninButton onClick={()=>signIn()}>
                        Sign In With Google
                    </SigninButton>
                </LoginForm>
            </Container>
        )
    }


export default Login

const Container= styled.div`
width:100%;
height:99vh;
background: #f8f8f8;
display:flex;
justify-content:center;
align-items:center;
`
const LoginForm= styled.div`
    padding:140px;
    background: white;
    box-shadow: 0 1px 3px rgb(0 0 0/12%), 0 1px 2px rgb(0 0 0/24);
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;

    h1{
        margin-top:10px;
    }
    `
const SlackImg= styled.img`
    width:100px;
    
`
const SigninButton= styled.button`
    padding: 8px 20px;
    margin-top:50px;
    color:white;
    background:#de5246 ;
    border:none;
    height:40px;
    bored-radius:4px;
    cursor:pointer;
    font-size:15px;
`
// 